import * as THREE from "three";
import { Context } from "../core/context";
import { DbLine } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  AnnotationDrawnModifyAcceptParams,
  AnnotationDrawnModifyReturnData,
  CommonColor,
  ElevationAnnotationModifyReturnData,
} from "@/core/Parameters";

class AnnotationDrawnModify implements IModifyOperation {
  private m_context: Context;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData: AnnotationDrawnModifyReturnData = {
    basePoints: [],
  };
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_callbackUnderway: (point: THREE.Vector3) => void;
  private m_basePointNum: number = 0;
  private m_isShift: Boolean = false;

  constructor(context: Context, params: AnnotationDrawnModifyAcceptParams) {
    this.m_context = context;
    this.m_callbackUnderway = params.callbackUnderway;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_basePointNum = params.basePointNum;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 55;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_isShift && this.m_points.length) {
      this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
        this.m_curPoint,
        this.m_points[this.m_points.length - 1]
      );
    }
    if (this.m_points.length < this.m_basePointNum) {
      if (this.m_points.length == this.m_basePointNum - 1) {
        this.m_TextLabel.SetVaule(
          "请点取最后一点,长按Shift锁定正交",
          TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );
      } else {
        if (this.m_points.length == 0) {
          this.m_TextLabel.SetVaule(
            "请点取起始点,长按Shift锁定正交",
            TextLabelLocation,
            new THREE.Vector3(1, 0, 0)
          );
        } else if (this.m_points.length > 0) {
          this.m_TextLabel.SetVaule(
            "请点取下一点,长按Shift锁定正交",
            TextLabelLocation,
            new THREE.Vector3(1, 0, 0)
          );
        }
      }

      if (this.m_points.length > 0) {
        this.updateAuxLine();
      }
    } else {
      // TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 55;
      this.m_TextLabel.SetVaule(
        "点位已选取成功，请结束操作",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_points.length < this.m_basePointNum) {
      this.m_points.push(this.m_curPoint.clone());
      if (this.m_points.length == 1) {
        this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
      }
      this.m_callbackUnderway(this.m_curPoint.clone());
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }
  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      this.m_returnData.basePoints = [...this.m_points];
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private updateAuxLine() {
    let ps: THREE.Vector3[] = [];
    let points = [...this.m_points, this.m_curPoint];
    for (let i = 0; i < points.length - 1; i++) {
      ps.push(points[i], points[i + 1]);
    }

    this.m_auxLine?.geometry.setFromPoints(ps);
    this.m_auxLine?.computeLineDistances();
  }

  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel?.dispose();
  }
}

export { AnnotationDrawnModify };
